/**
 * Asynchronously loads the component
 */
// @ts-expect-error
import Loadable from 'react-loadable';
import Spinner from '../../components/SpinnerContainer';

export default Loadable({
  loader: () => import(/* webpackChunkName: "SelectPropertyPage.loadable" */ './index'),
  loading: Spinner,
});
